import { useState, useEffect, useRef } from "react";
import "./slider.css";

import Slide1 from "./bsp2.JPG";
import Slide2 from "./bsp4.JPG";
import Slide3 from "./bg1.png";

const slides = [
  {
    image: Slide1,
    caption: "Learn MERN Stack",
    desc: "Master MongoDB, Express, React, and Node.js with real-world projects."
  },
  {
    image: Slide2,
    caption: "Java Full Stack",
    desc: "End-to-end Java development including Spring Boot & Microservices."
  },
  {
    image: Slide3,
    caption: "Data Science",
    desc: "Data analysis, visualization, and machine learning using Python."
  }
];

export default function SliderComponent() {
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(true);
  const slideInterval = useRef(null);

  const totalSlides = slides.length;

  // Auto play
  useEffect(() => {
    startAutoPlay();

    // Stop & restart autoplay on tab switch
    const handleVisibility = () => {
      if (document.hidden) {
        stopAutoPlay();
      } else {
        // reset index if it went out of range
        setCurrent((prev) => prev % totalSlides);
        startAutoPlay();
      }
    };

    document.addEventListener("visibilitychange", handleVisibility);

    return () => {
      stopAutoPlay();
      document.removeEventListener("visibilitychange", handleVisibility);
    };
  }, []);

  const startAutoPlay = () => {
    stopAutoPlay();
    slideInterval.current = setInterval(() => {
      setCurrent((prev) => prev + 1);
    }, 3000);
  };

  const stopAutoPlay = () => {
    if (slideInterval.current) clearInterval(slideInterval.current);
  };

  // Handle transition end
  const handleTransitionEnd = () => {
    if (current === totalSlides) {
      // Jump instantly to real first slide
      setIsTransitioning(false);
      setCurrent(0);
    }
  };

  // Re-enable transition after jump
  useEffect(() => {
    if (!isTransitioning) {
      requestAnimationFrame(() => setIsTransitioning(true));
    }
  }, [isTransitioning]);

  return (
    <div className="slider">
      <div
        className="slider-track"
        style={{
          transform: `translateX(-${(current % (totalSlides + 1)) * 100}%)`,
          transition: isTransitioning ? "transform 0.8s ease-in-out" : "none"
        }}
        onTransitionEnd={handleTransitionEnd}
      >
        {slides.map((slide, index) => (
          <div className="slide" key={index}>
            <img src={slide.image} alt={slide.caption} />
            <div className="caption">
              <h2>{slide.caption}</h2>
              <p>{slide.desc}</p>
            </div>
          </div>
        ))}

        {/* Duplicate first slide */}
        <div className="slide">
          <img src={slides[0].image} alt={slides[0].caption} />
          <div className="caption">
            <h2>{slides[0].caption}</h2>
            <p>{slides[0].desc}</p>
          </div>
        </div>
      </div>

      {/* dots navigation */}
      <div className="dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={current % totalSlides === index ? "dot active" : "dot"}
            onClick={() => setCurrent(index)}
          ></span>
        ))}
      </div>
    </div>
  );
}